"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var getSize = exports.getSize = function getSize(initial) {
  return typeof initial === "number" ? initial + "px" : initial || "100%";
};